import { JWT_STORAGE_KEY, JWT_REFRESH_STORAGE_KEY } from './constant';

// ----------------------------------------------------------------------

export function jwtDecode(token: string) {
  try {
    if (!token) return null;

    const parts = token.split('.');
    if (parts.length < 2) {
      throw new Error('Invalid token!');
    }

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const decoded = JSON.parse(atob(base64));

    return decoded;
  } catch (error) {
    console.error('Error decoding token:', error);
    throw error;
  }
}

// ----------------------------------------------------------------------

export function isValidToken(accessToken: string) {
  if (!accessToken) {
    return false;
  }

  try {
    const decoded = jwtDecode(accessToken);

    if (!decoded || !('exp' in decoded)) {
      return false;
    }

    const currentTime = Date.now() / 1000;

    return decoded.exp > currentTime;
  } catch (error) {
    console.error('Error during token validation:', error);
    return false;
  }
}

// ----------------------------------------------------------------------

/**
 * Persist (or clear) the admin session tokens.
 *
 * Expiry is NOT handled with a timer + alert anymore: an expired access token is
 * caught reactively by the axios response interceptor, which silently refreshes
 * it (or signs the user out). Pass `refreshToken` on sign-in; on refresh we only
 * rotate the access token so it can be omitted. Passing `null` clears both.
 *
 * The access token is read per-request by the axios request interceptor
 * straight from sessionStorage, so there is no axios-default header to keep in
 * sync here.
 */
export async function setSession(accessToken: string | null, refreshToken?: string | null) {
  try {
    if (accessToken) {
      sessionStorage.setItem(JWT_STORAGE_KEY, accessToken);

      if (refreshToken) {
        sessionStorage.setItem(JWT_REFRESH_STORAGE_KEY, refreshToken);
      }
    } else {
      sessionStorage.removeItem(JWT_STORAGE_KEY);
      sessionStorage.removeItem(JWT_REFRESH_STORAGE_KEY);
    }
  } catch (error) {
    console.error('Error during set session:', error);
    throw error;
  }
}
